import React from 'react';
import SGTitle from 'components/Typography/SGTitle';
import SGSubtitle from 'components/Typography/SGSubtitle';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import TunnelStatusIndicator from 'features/POSRegisters/POSTable/NetworkCircuit/components/TunnelStatusIndicator';

const StyledDetailsContainer = styled(Grid)`
  display: grid;
  grid-template-columns: auto auto;
  gap: 16px;
  padding-top: 8px;
`;

const StyledDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const StyledTunnelStatus = styled.div`
  display: flex;
  align-items: center;
  text-transform: capitalize;
`;

export default function NetworkCircuitDetails({
  circuitName,
  localExchangeCarrier,
  ipV4Address,
  tunnelStatus,
  uploadSpeedThroughput,
  uploadSpeedBandwidth,
  downloadSpeedThroughput,
  downloadSpeedBandwidth,
}: any) {
  return (
    <StyledDetailsContainer>
      <StyledDetails>
        <SGTitle className="t6 text-color">Interface</SGTitle>
        <SGSubtitle className="s2">{circuitName ?? ''}</SGSubtitle>
      </StyledDetails>
      <StyledDetails>
        <SGTitle className="t6 text-color">Local Exchange Carrier</SGTitle>
        <SGSubtitle className="s2">{localExchangeCarrier ?? ''}</SGSubtitle>
      </StyledDetails>
      <StyledDetails>
        <SGTitle className="t6 text-color">IP Address</SGTitle>
        <SGSubtitle className="s2">{ipV4Address ?? ''}</SGSubtitle>
      </StyledDetails>
      <StyledDetails>
        <SGTitle className="t6 text-color">Tunnel Status</SGTitle>
        <StyledTunnelStatus>
          <TunnelStatusIndicator status={tunnelStatus?.toLowerCase()} />
          <SGSubtitle className="s2">{tunnelStatus ?? ''}</SGSubtitle>
        </StyledTunnelStatus>
      </StyledDetails>
      <StyledDetails>
        <SGTitle className="t6 text-color">Upload Speed</SGTitle>
        <SGSubtitle className="s2">
          {uploadSpeedThroughput ?? ''} / {uploadSpeedBandwidth ?? ''}
        </SGSubtitle>
      </StyledDetails>
      <StyledDetails>
        <SGTitle className="t6 text-color">Download Speed</SGTitle>
        <SGSubtitle className="s2">
          {downloadSpeedThroughput ?? ''}/{downloadSpeedBandwidth ?? ''}
        </SGSubtitle>
      </StyledDetails>
    </StyledDetailsContainer>
  );
}
